"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Attribution = _interopRequireDefault(require("composer-lib/components/clips/Attribution"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ClipLegalPopover = _interopRequireDefault(require("composer-lib/components/clips/ClipLegalPopover"));

var _constants = require("composer-plugins/lib/constants");

var _draftJs = require("draft-js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _default = (0, _createReactClass.default)({
  displayName: "ClipComponent",
  propTypes: {
    block: _propTypes.default.object.isRequired,
    blockProps: _propTypes.default.object.isRequired,
    contentState: _propTypes.default.object.isRequired
  },
  contextTypes: {
    getEditorState: _propTypes.default.func.isRequired,
    getReadOnly: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      entity: this.props.blockProps.entity,
      loaded: !this.props.blockProps.entity.getData().type === _constants.CLIP_TYPES.IMAGE,
      selected: false,
      successClicked: false
    };
  },
  componentDidMount: function componentDidMount() {
    var onInsertableLoaded = this.props.blockProps.onInsertableLoaded;
    document.body.addEventListener('click', this.onBodyClicked);

    if (this.getClipType() !== _constants.CLIP_TYPES.IMAGE) {
      onInsertableLoaded();
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    var getCommentsOnly = nextProps.blockProps.getCommentsOnly;
    var getReadOnly = this.context.getReadOnly;
    var _this$state = this.state,
        entity = _this$state.entity,
        loaded = _this$state.loaded,
        selected = _this$state.selected,
        successClicked = _this$state.successClicked;
    return !getReadOnly() && !getCommentsOnly() && (nextState.selected !== selected || nextState.entity !== entity || nextState.loaded !== loaded || nextState.successClicked !== successClicked);
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.state.selected) {
      this.forceSelectionOfImageBlock();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    document.body.removeEventListener('click', this.onBodyClicked);
  },
  onImageLoaded: function onImageLoaded() {
    this.props.blockProps.onInsertableLoaded();
    this.setState({
      loaded: true
    });
  },
  onBodyClicked: function onBodyClicked(e) {
    var imageEl = _reactDom.default.findDOMNode(this._container);

    if (imageEl && (e.target === imageEl || imageEl.contains(e.target))) {
      this.toggleSelected();
    } else if (this.state.selected) {
      this.setState({
        selected: false
      });
    }
  },
  getEntityKey: function getEntityKey() {
    return this.props.block.getEntityAt(0);
  },
  getEntity: function getEntity() {
    var key = this.getEntityKey();
    return key ? this.props.contentState.getEntity(key) : null;
  },
  forceSelectionOfImageBlock: function forceSelectionOfImageBlock() {
    var key = this.props.block.key;
    var _this$context = this.context,
        getEditorState = _this$context.getEditorState,
        onChange = _this$context.onChange;
    window.getSelection().removeAllRanges();

    var selectionState = _draftJs.SelectionState.createEmpty(key).merge({
      anchorOffset: 1,
      focusOffset: 1
    });

    onChange(_draftJs.EditorState.forceSelection(getEditorState(), selectionState));
  },
  toggleSelected: function toggleSelected() {
    this.setState(function (prevState) {
      return {
        selected: !prevState.selected
      };
    });
  },
  onCloseClick: function onCloseClick() {
    var key = this.props.block.key;
    var _this$context2 = this.context,
        getEditorState = _this$context2.getEditorState,
        onChange = _this$context2.onChange;
    var editorState = getEditorState();
    var rawContent = editorState.getCurrentContent().getBlockMap();

    var contentWithoutImage = _draftJs.ContentState.createFromBlockArray(rawContent.remove(key).toArray());

    onChange(_draftJs.EditorState.push(editorState, contentWithoutImage, 'remove-range'));
  },
  updateEntity: function updateEntity() {
    var _this$context3 = this.context,
        getEditorState = _this$context3.getEditorState,
        onChange = _this$context3.onChange; // mark that an entity changed so that we can check it later for "save to API" decision

    onChange(_draftJs.EditorState.set(getEditorState(), {
      lastChangeType: 'apply-entity'
    }));
    var entity = this.getEntity();
    this.setState({
      entity: entity
    });
  },
  updateAttribution: function updateAttribution(attribution) {
    var contentState = this.props.contentState;
    var key = this.getEntityKey();

    if (!key) {
      return;
    }

    contentState.mergeEntityData(key, {
      attribution: attribution
    });
    this.updateEntity();
  },
  onSuccessClick: function onSuccessClick(userId, key, value) {
    var updateUserAttribute = this.props.blockProps.updateUserAttribute;
    updateUserAttribute(userId, key, value);
    this.setState({
      successClicked: true
    });
  },
  getClipType: function getClipType() {
    var entity = this.state.entity;

    if (!entity) {
      return null;
    }

    return entity.getData().type;
  },
  renderAttribution: function renderAttribution() {
    var entity = this.getEntity();

    var _entity$getData = entity.getData(),
        attribution = _entity$getData.attribution;

    var blockProps = this.props.blockProps;
    var readOnly = blockProps.getReadOnly() || blockProps.getCommentsOnly();
    return _react.default.createElement(_Attribution.default, {
      attribution: attribution,
      isCollectBeta: blockProps.getIsCollectBeta(),
      readOnly: readOnly,
      updateAttribution: this.updateAttribution
    });
  },
  renderQuote: function renderQuote() {
    var _this = this;

    var _this$state2 = this.state,
        entity = _this$state2.entity,
        selected = _this$state2.selected;

    var _entity$getData2 = entity.getData(),
        quote = _entity$getData2.quote;

    var className = (0, _classnames.default)({
      selected: selected
    });
    return _react.default.createElement("blockquote", {
      className: className,
      ref: function ref(c) {
        return _this._container = c;
      }
    }, _react.default.createElement("div", null, quote));
  },
  renderImage: function renderImage() {
    var _this2 = this;

    var _this$props$blockProp = this.props.blockProps,
        getAuth = _this$props$blockProp.getAuth,
        getUserAttributes = _this$props$blockProp.getUserAttributes;
    var _this$state3 = this.state,
        entity = _this$state3.entity,
        loaded = _this$state3.loaded,
        selected = _this$state3.selected,
        successClicked = _this$state3.successClicked;

    var _entity$getData3 = entity.getData(),
        attribution = _entity$getData3.attribution,
        name = _entity$getData3.name,
        src = _entity$getData3.src;

    var className = (0, _classnames.default)({
      selected: selected
    });
    return _react.default.createElement(_ClipLegalPopover.default, {
      auth: getAuth(),
      canShow: loaded && !successClicked,
      onCancelClick: this.onCloseClick,
      onSuccessClick: this.onSuccessClick,
      userAttributes: getUserAttributes()
    }, _react.default.createElement(_UIImage.default, {
      alt: name || attribution,
      className: className,
      onLoad: this.onImageLoaded,
      ref: function ref(c) {
        return _this2._container = c;
      },
      responsive: false,
      src: src
    }));
  },
  renderClip: function renderClip() {
    var type = this.getClipType();

    if (!type) {
      return null;
    }

    switch (type) {
      case _constants.CLIP_TYPES.QUOTE:
        return this.renderQuote();

      case _constants.CLIP_TYPES.IMAGE:
      default:
        return this.renderImage();
    }
  },
  render: function render() {
    var renderedClip = this.renderClip();

    if (!renderedClip) {
      return null;
    }

    return _react.default.createElement("div", null, renderedClip, this.renderAttribution());
  }
});

exports.default = _default;
module.exports = exports.default;